exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shadowbox, .DryRunSeries-Row {\n  -webkit-box-shadow: 1px 1px 2px 0px grey !important;\n  -moz-box-shadow: 1px 1px 2px 0px grey !important;\n  box-shadow: 1px 1px 2px 0px grey !important;\n  border: 1px solid silver !important;\n  border-top: 0px !important; }\n\n.DryRunSeries-Row {\n  padding: 15px;\n  display: inline-block;\n  width: 100%;\n  margin-bottom: 5px; }\n", ""]);

// exports
